<template>
    <HeaderComponent :showExtras="false" />
    <div>
        <Heading title="Privacidade" class="xl:px-[16vw]"/>
        <div class="p-4 xl:px-[16vw]">
            <div>{{ privacy.text }}</div>
        </div>
    </div>
</template>
<script>
import Heading from '@/Components/UI/Texts/Heading.vue'

export default {
    components: {
        Heading,
    },
    props: {
        privacy: Object,
    },
}
</script>
